import React, { useState } from "react";
import { InvoicesDashboard } from "./InvoicesDashboard";
import { CreateInvoiceForm } from "./CreateInvoiceForm";
import { ViewInvoiceDetails } from "./ViewInvoiceDetails";
import { EditInvoiceForm } from "./EditInvoiceForm";
import { Invoice } from "@/types/invoice";
import InvoiceAPIService from "@/services/invoice-api";

type ViewState = "dashboard" | "create" | "view" | "edit";

export function InvoicesContainer() {
  const [currentView, setCurrentView] = useState<ViewState>("dashboard");
  const [selectedInvoice, setSelectedInvoice] = useState<Invoice | null>(null);

  const handleCreateInvoice = () => {
    setCurrentView("create");
  };

  const handleViewInvoice = (invoice: Invoice) => {
    setSelectedInvoice(invoice);
    setCurrentView("view");
  };

  const handleEditInvoice = (invoice: Invoice) => {
    setSelectedInvoice(invoice);
    setCurrentView("edit");
  };

  const handleCancelCreate = () => {
    setCurrentView("dashboard");
  };

  const handleCreateSuccess = () => {
    setCurrentView("dashboard");
  };

  const handleBackToDashboard = () => {
    setSelectedInvoice(null);
    setCurrentView("dashboard");
  };

  const handleBackToView = () => {
    setCurrentView("view");
  };

  const handleBackToDashboardFromEdit = () => {
    setSelectedInvoice(null);
    setCurrentView("dashboard");
  };

  const handleEditSuccess = async () => {
    // After successful edit, refresh the invoice data and go back to view
    if (selectedInvoice) {
      try {
        const updatedInvoice = await InvoiceAPIService.getInvoiceDetails(selectedInvoice.id);
        setSelectedInvoice(updatedInvoice);
        setCurrentView("view");
      } catch (error) {
        console.error("Error fetching updated invoice:", error);
        // If we can't fetch updated data, just go back to view with current data
        setCurrentView("view");
      }
    } else {
      // Fallback to dashboard if no selected invoice
      setCurrentView("dashboard");
    }
  };

  if (currentView === "create") {
    return (
      <CreateInvoiceForm
        onCancel={handleCancelCreate}
        onSuccess={handleCreateSuccess}
      />
    );
  }

  if (currentView === "edit" && selectedInvoice) {
    return (
      <EditInvoiceForm
        invoice={selectedInvoice}
        onCancel={handleBackToDashboardFromEdit}
        onSuccess={handleEditSuccess}
      />
    );
  }

  if (currentView === "view" && selectedInvoice) {
    return (
      <ViewInvoiceDetails
        invoice={selectedInvoice}
        onBack={handleBackToDashboard}
        onEdit={handleEditInvoice}
      />
    );
  }

  return (
    <InvoicesDashboard 
      onCreateInvoice={handleCreateInvoice}
      onViewInvoice={handleViewInvoice}
      onEditInvoice={handleEditInvoice}
    />
  );
} 